import { render } from "./UpdateUserInfoView.vue?vue&type=template&id=9c1e6868&scoped=true"
import script from "./UpdateUserInfoView.vue?vue&type=script&lang=js"
export * from "./UpdateUserInfoView.vue?vue&type=script&lang=js"

import "./UpdateUserInfoView.vue?vue&type=style&index=0&id=9c1e6868&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c1e6868"]])

export default __exports__